// Yandex metrika support

import { isServer } from "./env"

const counterID = "94581408"

export const ym = (action: string, params?: Record<string, any>) => {
  if (isServer || !window.ym) return
  if (action == "disable") {
    window[`disableYaCounter${counterID}`] = true
    return
  }

  try {
    window.ym(counterID, action, params)
  } catch (error) {
    console.error("Yandex Metrika error:", error)
  }
}
